import Vue from 'vue'
import Vuex from 'vuex'

import {lowercaseKeys} from 'util'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    identifier: null,
    lang: 'en',
    meta: [],
    menu: [],
    header: null,
    sections: null,
    credits: null,
    nextChapter: null,
    relatedarticles: null,
    fbcomment: null,
    premium: false,
    user: null,
    eventsdata: [],
    eventsconstituencies: [],
    eventpopdata: {},
    eventsondate: [],
    variableData: {},
    candidates: {},
    constituencies: {},
    parties: {}
  },
  getters: {},
  mutations: {
    identifier (state, identifier) {
      state.identifier = identifier
    },
    pushResponse (state, response) {
      const responseKeys = {
        lang: 'lang',
        meta: 'meta',
        menu: 'menu',
        header: 'header',
        sections: 'sections',
        credits: 'credits',
        nextChapter: 'next_chapter',
        relatedarticles: 'relatedarticles',
        fbcomment: 'fbcomment',
        premium: 'premium',
        user: 'user',
        eventsdata: 'eventsdata',
        eventsconstituencies: 'eventsconstituencies',
        eventpopdata: 'eventpopdata',
        eventsondate: 'eventsondate',
        variableData: 'variableData',
        candidates: 'candidates',
        constituencies: 'constituencies',
        parties: 'parties'
      }
      Object.keys(responseKeys).forEach(key => {
        const value = response[responseKeys[key]]
        if (value == null) return
        state[key] =
          typeof value !== 'object' || Array.isArray(value)
            ? value
            : lowercaseKeys(value)
      })
    }
  },
  actions: {},
  strict: process.env.NODE_ENV !== 'production'
})
